import { ConditionedResultResponse, RunResults } from "@custom-types/modelRun"
import { ThresholdFormValues } from "@features/results/Result/ThresholdChartContainer/ThresholdForm"

export const conditionedResultResponseToProbabilityDensityChartResults = (
  response: ConditionedResultResponse,
  formValues: ThresholdFormValues,
  runKey: string,
): RunResults => {
  return {
    [runKey]: {
      Unconditioned: [
        {
          data: response.unconditioned.samples,
          key: runKey,
          timestep: Number(formValues.event.timestep),
          node_key: "Unconditioned",
          unit_format: "",
        },
      ],
      Conditioned: [
        {
          data: response.conditioned.samples,
          key: runKey,
          timestep: Number(formValues.event.timestep),
          node_key: "Conditioned",
          unit_format: "",
        },
      ],
    },
  }
}
